import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.96" d="M13.71 15.8l5.44-5.44m0 0l.74-4.9 4.24-4.16.65 3.43 3.43.65-4.17 4.24-4.89.74zM26.8 12.74a12.72 12.72 0 11-11-9.41M21.16 14.33a6.85 6.85 0 11-6.66-5.2" /></svg>);